<template>
  <div class="mod-purchase-order">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="pageIndex = 1; getDataList()">
      <el-form-item label="采购单号">
        <el-input v-model="dataForm.purchaseOrderCode" size="small" clearable />
      </el-form-item>
      <el-form-item label="供应商名称">
        <el-input v-model="dataForm.supplierName" size="small" clearable />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="dataForm.orderStatus" clearable size="small" style="width:120px">
          <el-option label="开立" value="0" />
          <el-option label="已确认" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:purchaseOrder:list')" type="primary" size="small" @click="pageIndex = 1; getDataList()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:purchaseOrder:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="dataList" border v-loading="dataListLoading" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" @row-dblclick="row => open(row.purchaseOrderId, true)">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="purchaseOrderCode" label="采购单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('purchase:purchaseOrder:info')" class="code-link" @click="addOrUpdateHandle(scope.row.purchaseOrderId, true)">{{ scope.row.purchaseOrderCode }}</a>
          <span v-else>{{ scope.row.purchaseOrderCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="供应商" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="orderDate" label="订购日期" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ (scope.row.orderDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="totalQuantity" label="总数量" width="100" header-align="center" align="left" />
      <el-table-column prop="receivedQuantity" label="已入库" width="100" header-align="center" align="left">
        <template slot-scope="scope">{{ formatQty(scope.row.receivedQuantity) }}</template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="总金额" width="110" header-align="center" align="left" />
      <el-table-column prop="orderStatus" label="状态" width="90" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="String(scope.row.orderStatus) === '2'" type="success" size="small">已确认</el-tag>
          <el-tag v-else type="info" size="small">开立</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="val => { pageSize = val; pageIndex = 1; getDataList() }"
      @current-change="val => { pageIndex = val; getDataList() }"
      :current-page="pageIndex"
      :page-sizes="[20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    />

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" />
  </div>
</template>

<script>
import AddOrUpdate from './purchaseOrder-add-or-update'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'PurchaseOrder',
  components: { AddOrUpdate },
  data() {
    return {
      dataForm: { purchaseOrderCode: '', supplierName: '', orderStatus: '' },
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      permCodes: []
    }
  },
  created() {
    this.loadPerms()
    this.getDataList()
  },
  activated() {
    this.getDataList()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    },
    getDataList() {
      this.dataListLoading = true
      request.post('/purchase/purchaseOrder/list', {
        currentPage: this.pageIndex,
        pageSize: this.pageSize,
        code: this.dataForm.purchaseOrderCode,
        partnerName: this.dataForm.supplierName,
        status: this.dataForm.orderStatus
      }).then(res => {
        const body = res.data || {}
        this.dataList = body.list || []
        this.totalPage = body.totalCount || 0
      }).catch(() => {}).finally(() => { this.dataListLoading = false })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, readonly)
      })
    },
    open(id, readonly) {
      this.addOrUpdateHandle(id, !!readonly)
    },
    formatQty(val) {
      if (val == null || val === '') return '0'
      const n = Number(val)
      return Number.isNaN(n) ? '0' : n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.code-link { color: #348adb; cursor: pointer; }
</style>
